import {Component} from '@angular/core';

@Component({
    selector: 'dashboard',
    template: require('./dashboard.template.html')
})
export class DashboardComponent {

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/dashboard/dashboard.component.ts